import React from "react";
import { useTranslation } from "react-i18next";
import { OcFormEditorItemList } from "oc/components";
import { useOcFormEditorSelector } from "oc/hooks";
import getNationalities from "oc/utils/get-nationalities";

interface OcFormEditorNationalitySelectorProps {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const OcFormEditorNationalitySelector: React.FC<
  OcFormEditorNationalitySelectorProps
> = ({ name, label, value, onChange, error }) => {
  const { i18n } = useTranslation();
  const nationalities = getNationalities(i18n.language);

  const {
    list,
    search,
    selectedItem,
    handleSearch,
    handleClearSearch,
    handleHasMore,
  } = useOcFormEditorSelector({
    value,
    list: nationalities,
  });

  return (
    <OcFormEditorItemList
      search={search}
      onSearch={handleSearch}
      onChange={onChange}
      onClearSearch={handleClearSearch}
      list={list}
      onScroll={handleHasMore}
      value={selectedItem}
      label={label}
      name={name}
      error={!!error}
    />
  );
};

export default OcFormEditorNationalitySelector;
